export default __webpack_public_path__ + "static/media/Screenshot12.3d14ed57.png";